import { render, staticRenderFns } from "./materialInputViewTable.vue?vue&type=template&id=2a7a062a&scoped=true&"
import script from "./materialInputViewTable.vue?vue&type=script&lang=js&"
export * from "./materialInputViewTable.vue?vue&type=script&lang=js&"
import style0 from "./materialInputViewTable.vue?vue&type=style&index=0&id=2a7a062a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7a062a",
  null
  
)

export default component.exports